import Layout from '@/views/layout'
import error from './error'
import learn from './learn/learn'
import lesson from './lesson/lesson'
import report from './report/report'
import home from './home/home'
import level from './level/level'
import user from './user'
import achievement from './achievement/achievement'
import record from './record/record'
import mall from './mall'
import team from './team'
export default [
    {
        path: '/',
        component: Layout,
        children: [
            ...home,
            ...lesson,
            ...report,
            ...level,
            ...record,
            ...mall,
        ],
    },
    ...user,
    ...learn,
    ...achievement,
    ...error,
    ...record,
    ...team,

]
